import React from "react"
import { Field, WrappedFieldProps } from "redux-form"
import styled from "styled-components"
import Color from "../../../../../../style/enum/color"
import { Error } from "../../../../../parts/form-error-string-wrapper"

export const TitleInput = (props: WrappedFieldProps) => {
  return (
    <div>
      <SetQuestion>
        <Field
          name="title"
          type="text"
          component="input"
          placeholder={`質問を入力してください`}
        />
      </SetQuestion>
      {props.meta.submitFailed && <Error>{props.meta.error}</Error>}
    </div>
  )
}

const SetQuestion = styled.div`
  border-bottom: 2px solid ${Color.BRAND};
  font-size: 1rem;
  & > input {
    width: 100%;
    padding: 4px 8px;
    box-sizing: border-box;
  }
`
